import { useMutation, useQueryClient } from 'react-query';
import { API } from '../../../CommonUtils/axiosWithDefaults';
import { ApplyReconciliationResult, Decisions } from '../pdfReconciliationTypes';
import { queryKeys } from './queryKeys';

interface ApplyParams {
  batchId: string;
  itemId: string;
  clientId: number;
  decisions: Decisions;
}

const applyReconciliation = async ({
  batchId,
  itemId,
  decisions,
}: ApplyParams): Promise<ApplyReconciliationResult> => {
  return API.post('/Adviser/PdfImport/ApplyReconciliation', { batchId, itemId, decisions });
};

/**
 * On a successful apply we invalidate the reconciliation polling key so the wizard
 * sees the final status. Full client data refresh runs when the wizard closes.
 */
export const useApplyReconciliationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(applyReconciliation, {
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(queryKeys.reconciliation(variables.batchId, variables.itemId));
    },
  });
};
